import moment from 'moment';

// 以傳入this的方式處理
export function textInputOnChange(e, ownerThis, cb) {
  const jsInp = e.currentTarget,
        id = jsInp.id,
        value = cb ? cb(id, jsInp.value) : jsInp.value;

  ownerThis.setState({[id]: value});
}

// 不傳入this，改以回傳物件的方式處理
export function dateOnChange(selection, stateName, dateStateNames, dateStateValues) {
	if(!selection._isAMomentObject) selection = selection.value;
	
	const newStates = {
		[stateName]: selection
	};

	const {dayStateName, hourStateName, minuteStateName} = dateStateNames || {},
				{dayStateValue, hourStateValue, minuteStateValue} = dateStateValues || {};

	// 智慧填滿
	switch (stateName) {
		case dayStateName:
			if(!hourStateValue) newStates[hourStateName] = '10';
			if(!minuteStateValue) newStates[minuteStateName] = '00';
			break;
		case hourStateName:
			if(!dayStateValue) newStates[dayStateName] = moment();
			if(!minuteStateValue) newStates[minuteStateName] = '00';
			break;
		case minuteStateName:
			if(!dayStateValue) newStates[dayStateName] = moment();
			if(!hourStateValue) newStates[hourStateName] = '10';
			break;
		default:
			
	}


	return newStates;

}

export function dropDownOnChange(selection, stateName) {
	return {
		[stateName]: selection.value
	}
}


// WEBPACK FOOTER //
// ./src/commonJS/onFormChanges.js